module.exports = __webpack_public_path__ + "static/media/chave_dicotomica.a8d442ef.jpg";